import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ADD_VENUE_NAMES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { addVenueNamesSuccess } from 'Actions';

const AddVenueNamesEpic = (action$) =>
  action$.pipe(
    ofType(ADD_VENUE_NAMES_REQUEST),
    debounceTime(500),
    switchMap(({ link }) =>
      from(service.get(`${import.meta.env.VITE_API_DOMAIN}${link}`)).pipe(
        map((response) => addVenueNamesSuccess(response)),
        catchError((error) => {
          console.error('AddVenueNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default AddVenueNamesEpic;
